function dateRange() {

    let calendarFrom  =  $('#_js-calendar-start');
    let calendarTo    =  $('#_js-calendar-end');

    if ( calendarFrom.length && calendarTo.length ) {
        let dateFormat = "dd.mm.yyyy";
        const options = {
            defaultDate: "+1w",
            changeMonth: true,
            changeYear: true,
            numberOfMonths: 1,
            dateFormat: dateFormat,
            monthNamesShort: [
                "Январь",
                "Февраль",
                "Март",
                "Апрель",
                "Май",
                "Июнь",
                "Июль",
                "Август",
                "Сентябрь",
                "Октябрь",
                "Ноябрь",
                "Декабрь"
            ],
            dayNamesMin: ["Вск", "Пн", "Вт", "Ср", "Чт", "Птн", "Сб"],
            firstDay: 1
        };
        let from = calendarFrom.datepicker(options)
                .on( "change", function() {
                    to.datepicker( "option", "minDate", getDate( this ) );
                }),
            to = calendarTo.datepicker(options)
                .on( "change", function() {
                    from.datepicker( "option", "maxDate", getDate( this ) );
                });

        function getDate( element ) {
            let date;
            try {
                date = $.datepicker.parseDate( dateFormat, element.value );
            } catch( error ) {
                date = null;
            }
            return date;
        }

        /*calendarFrom.datepicker({
            onSelect: function() {
                calendarFrom.change();
            }
        });
        calendarTo.datepicker({
            onSelect: function() {
                calendarFrom.change();
            }
        });*/

        $('body').on('scroll', function(){
            $('#_js-calendar-start, #_js-calendar-end').datepicker('hide').blur();
        });
        $(window).on('resize', function(){
            $('#_js-calendar-start, #_js-calendar-end').datepicker('hide').blur();
        });

    }

}